import React from "react";
import { useIsMobile } from "../../../custom-hooks";
import ThumbnailImage from "../../../components-new/Thumbnail";
import { useStore } from "../../../helpers";
import { FileIcon, defaultStyles } from "react-file-icon";
import { safe_get } from "../../../report-visuals";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

export const MediaCard = (props: any) => {
    const { media, onMediaDelete } = props; // 👈 receive delete handler
    const isMobile = useIsMobile();
    const { userStore } = useStore();

    const isVideo = media?.type?.startsWith("video/");
    const isImage = media?.type?.startsWith("image/");
    const hasMedia = media?.mediapath;
    const fileType = media?.type?.split("/")?.[1] || "mp4";

    const handleMediaClick = async () => {
        if (!hasMedia) return;

        if (isImage) {
            userStore.set_selected_image({
                s3Key: media.mediapath,
                bucket: "urn-assets",
                width: isMobile ? 300 : 800,
                height: isMobile ? 300 : 600,
            });
            await userStore.update_thumbnail_modal(true);
        } else {
            const videoUrl =
                safe_get(media, "s3_path", "") ||
                `https://urn-assets.s3.amazonaws.com/${media.mediapath}`;
            window.open(videoUrl, "_blank");
        }
    };

    return (
        <div key={media?.id} className="px-4 group relative">
            {!isMobile && onMediaDelete && (
                <button
                    onClick={(e) => {
                        e.stopPropagation();
                        onMediaDelete(media.id);
                    }}
                    className="
            absolute top-3 right-3 z-10
            bg-white rounded-full p-1
            shadow-md
            opacity-0 group-hover:opacity-100
            transition-opacity duration-200
            hover:bg-red-50
          "
                >
                    <DeleteOutlineIcon
                        fontSize="small"
                        className="text-red-600"
                    />
                </button>
            )}

            {/* MEDIA */}
            <div
                onClick={handleMediaClick}
                className="flex justify-center items-center h-[260px] bg-gray-100 cursor-pointer"
            >
                {!hasMedia ? (
                    <img
                        src="images/default_image.jpeg"
                        alt="Default"
                        className="h-full object-contain"
                    />
                ) : isVideo ? (
                    <div className="w-24 h-24">
                        <FileIcon
                            radius={1}
                            fold={true}
                            type="video"
                            extension={fileType}
                            {...defaultStyles[fileType]}
                        />
                    </div>
                ) : (
                    <ThumbnailImage
                        s3Key={media.mediapath}
                        bucket="urn-assets"
                        width={isMobile ? 300 : 600}
                        height={260}
                        fit="FILL"
                    />
                )}
            </div>

            {/* INFO */}
            <div className="bg-gray-300 opacity-50 rounded-sm p-2 mt-2">
                <p className="font-semibold">{media.title || "Untitled"}</p>
                <p className="text-sm text-gray-700">
                    {media.description || "No description"}
                </p>
            </div>
        </div>
    );
};
